import {
  Button,
  IPageLayout,
  Typography,
} from '@collection-platform-frontend/ui';
import { useRouter } from 'next/router';

type ErrorPageRenderProps = {
  PageLayout: IPageLayout;
  onHome?: () => void;
};

export const ErrorPageRender = ({
  PageLayout,
  onHome,
}: ErrorPageRenderProps) => {
  const Page = () => {
    const { push } = useRouter();

    const onBack = () => {
      if (onHome) {
        onHome();
      } else {
        push('/');
      }
    };

    return (
      <PageLayout>
        <div className="flex flex-col items-center justify-center py-16 mx-auto sm:py-48">
          <Typography variant="h2" className="mb-8 text-9xl">
            500
          </Typography>
          <Typography variant="h3" className="px-4 mb-8">
            <span
              dangerouslySetInnerHTML={{
                __html:
                  'エラーが発生しました。</br>この問題が何度も発生するようであれば、お手数ですが運営までお問い合わせください。',
              }}
            />
          </Typography>
          <Button primary className="w-[240px]" onClick={onBack}>
            トップへ戻る
          </Button>
        </div>
      </PageLayout>
    );
  };

  return Page;
};
